import { ISODateRange, StopsellApplyBlock, StopsellApplyRange } from '~/types/stopsell';

import { isSameRange, mergeDateRanges } from '~/utils/mergeDateRanges';

export type BlackoutSourceType = 'salesforce' | 'stopsell_doc';

export interface SourceBlackoutRange extends ISODateRange {
  id: string;
}

export interface TaggedBlackoutRange extends ISODateRange {
  source: BlackoutSourceType;
  sourceIds: Array<string>;
}

export function collapseWithinSource(
  ranges: Array<SourceBlackoutRange>,
  source: BlackoutSourceType,
): Array<TaggedBlackoutRange> {
  const tagged: Array<TaggedBlackoutRange> = ranges.map((range) => ({
    start: range.start,
    end: range.end,
    source,
    sourceIds: [range.id],
  }));

  return mergeDateRanges(tagged, (prev, next) => {
    prev.sourceIds = [...prev.sourceIds, ...next.sourceIds];
  });
}

export interface ReconcileBlackoutScheduleResult {
  blocksToDelete: Array<StopsellApplyBlock>;
  rangesToCreate: Array<StopsellApplyRange>;
}

export function reconcileBlackoutSchedule(
  roomRateId: string,
  desiredRanges: Array<ISODateRange>,
  existingBlocks: Array<App.BlackoutDate>,
): ReconcileBlackoutScheduleResult {
  const blocksToDelete = existingBlocks
    .filter(
      (existing) =>
        !desiredRanges.some((desired) => isSameRange(desired, { start: existing.start_date, end: existing.end_date })),
    )
    .map((existing) => ({ id: existing.id, room_rate_id: roomRateId }));

  const rangesToCreate = desiredRanges
    .filter(
      (desired) =>
        !existingBlocks.some((existing) =>
          isSameRange(desired, { start: existing.start_date, end: existing.end_date }),
        ),
    )
    .map((desired) => ({ start: desired.start, end: desired.end, roomRateId }));

  return { blocksToDelete, rangesToCreate };
}
